module.exports = __webpack_public_path__ + "static/media/AS.e8b12c5e.png";